export default function latLng(value) {
    let signChar = '';

    switch (Math.sign(value)) {
        case 1:
            signChar = '+';
            break;
        case -1:
            signChar = '-';
            break
    }

    return `${signChar}${Math.abs(value)}`;
}
